import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './schedulerContainer.scss';
import { useNavigate } from 'react-router-dom';
import { usePortal } from '../../context';
import SchedulerFormContainer from '../SchedulerFormContainer';
import { DEFAULT_SUCCESS_MESSAGE } from '../../features/Success';

const SchedulerContainer = ({ children }) => {
    const navigate = useNavigate();

    const {
        user: { partnerAccent, name, username },
        setSuccessMessage,
        fetchEvents,
    } = usePortal();

    return (
        <div className="scheduler-container">
            <div
                className="scheduler-container-background"
                style={{ backgroundColor: partnerAccent ? partnerAccent : undefined }}
            />
            <main className="main-content">
                <SchedulerFormContainer
                    title={`${name} Viewlogies Scheduler`}
                    onClose={() => {
                        setSuccessMessage(DEFAULT_SUCCESS_MESSAGE); // TODO: move to API?
                        // Refresh events before navigating back to dashboard
                        fetchEvents(username, 0);
                        navigate(`/${username}`);
                    }}
                >
                    {children}
                </SchedulerFormContainer>
            </main>
        </div>
    );
};

export default SchedulerContainer;
